var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleWLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 36,
    viewBox: "0 0 156 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7676_20330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0418 15.481V27.7662H40.4263V16.3608C40.4263 13.88 38.965 12.7172 37.1674 12.7172C35.1075 12.7172 33.6859 13.999 33.6859 16.8405V27.7662H28.0703V7.75721H33.6859V9.63942C34.6986 8.15919 36.5687 7.19824 39.0392 7.19824C42.8191 7.19824 46.0401 10.0793 46.0401 15.4827L46.0418 15.481Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0017 8.22949L61.2371 27.4553C59.0219 33.7575 55.5025 36.2556 49.9646 35.9778V30.4278C52.7335 30.4278 54.0395 29.5566 54.9073 27.1378L47.0352 8.22949H53.5616L57.9523 20.3595L61.6701 8.22949H68.0017Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9637 -0.000976562V28.2321H82.3964V26.3361C81.1715 27.8681 79.3532 28.7963 76.8654 28.7963C72.0038 28.7963 67.9961 24.1572 67.9961 18.1483C67.9961 12.1393 72.0055 7.50025 76.8654 7.50025C79.3532 7.50025 81.1715 8.42841 82.3964 9.9604V-0.000976562H87.9637ZM82.3964 18.15C82.3964 15.1257 80.5401 13.2279 77.9782 13.2279C75.4162 13.2279 73.5599 15.124 73.5599 18.15C73.5599 21.176 75.4162 23.072 77.9782 23.072C80.5401 23.072 82.3964 21.176 82.3964 18.15Z",
    fill: "#00CB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9531 17.9961C91.9531 11.9009 96.399 7.19629 101.937 7.19629C107.475 7.19629 111.921 11.9009 111.921 17.9961C111.921 24.0913 107.475 28.7959 101.937 28.7959C96.399 28.7959 91.9531 24.0913 91.9531 17.9961ZM106.271 17.9961C106.271 15.0926 104.387 13.169 101.937 13.169C99.4871 13.169 97.6049 15.0926 97.6049 17.9961C97.6049 20.8996 99.4871 22.8215 101.937 22.8215C104.387 22.8215 106.271 20.8996 106.271 17.9961Z",
    fill: "#00CB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.894 15.481V27.7662H127.28V16.3608C127.28 13.88 125.817 12.7172 124.021 12.7172C121.961 12.7172 120.54 13.999 120.54 16.8405V27.7662H114.926V7.75721H120.54V9.63942C121.552 8.15919 123.422 7.19824 125.895 7.19824C129.676 7.19824 132.896 10.0793 132.896 15.4827L132.894 15.481Z",
    fill: "#00CB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.602 23.3115C148.175 23.3115 149.519 22.6576 150.287 21.7588L154.895 24.5813C153.013 27.3623 150.171 28.7959 146.524 28.7959C139.958 28.7959 135.887 24.0913 135.887 17.9961C135.887 11.9009 140.034 7.19629 146.102 7.19629C151.707 7.19629 155.854 11.8199 155.854 17.9961C155.854 18.8553 155.778 19.6713 155.625 20.4511H141.992C142.722 22.5766 144.489 23.3132 146.602 23.3132V23.3115ZM150.134 15.8689C149.519 13.4968 147.791 12.6376 146.064 12.6376C143.874 12.6376 142.415 13.7849 141.878 15.8689H150.135H150.134Z",
    fill: "#00CB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63627 7.88063V20.9853L0.721139 18.1491L0.00172521 17.7316H0V11.8555C0 11.4156 0.234629 11.0084 0.615901 10.7876L5.63627 7.87891V7.88063Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9016 24.8565L6.35913 27.4875L5.63627 27.905L5.45167 28.0119L0.615901 25.2102C0.234629 24.9894 0 24.5822 0 24.1423V18.5664H0.00172521L5.63627 21.8167L6.35913 22.2325L10.9016 24.8548V24.8565Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5078 21.8613V28.4223L17.2921 28.5482L12.4512 31.3517C12.0682 31.5725 11.5972 31.5725 11.2142 31.3517L6.35774 28.5396L6.16797 28.4309L6.35774 28.3222L11.6196 25.2738L12.3373 24.8563H12.3391L17.5061 21.8631L17.5078 21.8613Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6662 18.2903V24.8547L18.2266 28.0032V15.1504L22.9485 17.8762L23.6662 18.2903Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6662 25.7021V28.4677C23.6662 28.6126 23.5885 28.7471 23.4609 28.8196L18.8442 31.4626C18.5699 31.6196 18.2266 31.4247 18.2266 31.1107V28.8179L18.7424 28.5229L23.6662 25.7039V25.7021Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6682 11.8576V17.4576L18.2286 14.3177L17.5091 13.902L12.7734 11.1675L17.5091 8.4244L18.2286 8.0069L18.2389 8L23.0522 10.7862C23.4335 11.007 23.6682 11.4142 23.6682 11.8541V11.8576Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5077 7.57866V7.59073L12.0526 10.753L11.3332 11.1688L6.35938 14.0517V7.46307L11.2158 4.65097C11.5988 4.43014 12.0698 4.43014 12.4528 4.65097L17.5094 7.58038L17.5077 7.57866Z",
    fill: "#2396E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7676_20330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155.849,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleWLogo);
export default __webpack_public_path__ + "static/media/title-w-logo.816490da0bb020027c21ccfdca066f52.svg";
export { ForwardRef as ReactComponent };